import React, { useEffect, useState } from "react";
import axios from "axios";

export function ProgressBarDownload({ url, knownSizeBytes, setUrl, setImageState }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let isMounted = true;

    const fetchImage = async () => {
      try {
        console.log(`getting image from ${url}`);
        const response = await axios.get(url, {
          responseType: "blob",
          onDownloadProgress: (event) => {
            if (!isMounted) return;

            if (event.total) {
              setProgress(Math.min((event.loaded / event.total) * 100, 100));
            } else if (knownSizeBytes) {
              setProgress(Math.min((event.loaded / knownSizeBytes) * 100, 100));
            } else {
              setProgress(null);
            }
          },
        });

        if (isMounted) {
          const blobUrl = URL.createObjectURL(response.data);
          setUrl(blobUrl);
          setImageState("loaded");
        }
      } catch (err) {
        console.error("Image download failed", err);
        if (isMounted) {
          setImageState("error");
        }
      }
    };

    fetchImage();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="download-wrapper">
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${progress}%` }}
        >
          {Math.floor(progress)}%
        </div>
      </div>
    </div>
  );
}
